import React, { useState } from "react"
import tw, { styled } from "twin.macro"
import { Link, isPartiallyActive } from "./index"

import { ChevronDown } from "react-feather"

const convertClassAttribute = (props) => {
  return {
    ...props,
    className: props.className.join(" "),
  }
}

const NavigationTray = ({ tree, aux, linkElement, remove }) => {
  //const [submenu, setSubmenu] = useState(null);
  const [active, setActive] = useState(null)

  return (
    <Style className="navigation navigation--tray">
      <ul>
        {tree.map((item, i) => {
          return (
            <li key={`top-${i}`}>
              {/*<Link
                                {...item}
                                elem={linkElement}
                                className="nav__link"
                                remove={remove}
                                getProps={isPartiallyActive}
                    />*/}
              {item.subtree.length > 0 ? (
                <React.Fragment>
                  <button
                    type="button"
                    aria-selected={item.link.url === active}
                    className="nav__link nav__link-toggle"
                    onClick={() =>
                      setActive(item.link.url === active ? null : item.link.url)
                    }
                  >
                    {item.link.title}
                    <ChevronDown aria-hidden="true" />
                  </button>
                  <ul className="nav__dropdown">
                    {item.subtree.map((sub, x) => (
                      <li key={`sub-${x}`}>
                        <Link
                          {...sub}
                          subtree={[]}
                          elem={linkElement}
                          remove={remove}
                          className="nav__sub-link"
                          activeClassName="is-active"
                          //to={sub.link.url}
                        />
                      </li>
                    ))}
                  </ul>
                </React.Fragment>
              ) : (
                <Link
                  {...item}
                  elem={linkElement}
                  className="nav__link"
                  remove={remove}
                  getProps={isPartiallyActive}
                />
              )}
            </li>
          )
        })}

        {aux.map((item, i) => {
          return (
            <li key={`top-${i}`}>
              {item.link.options?.attributes?.target ? (
                <a
                  href={item.link.url}
                  {...convertClassAttribute(item.link.options?.attributes)}
                >
                  {item.link.title}
                </a>
              ) : (
                <Link
                  {...item}
                  elem={linkElement}
                  className="nav__link"
                  remove={remove}
                  getProps={isPartiallyActive}
                  {...convertClassAttribute(item.link.options?.attributes)}
                />
              )}
            </li>
          )
        })}
      </ul>
    </Style>
  )
}
export default NavigationTray

const Style = styled.nav`
  overflow-y: auto;

  --line-height: calc(1em + 24px);

  ul {
    ${tw`text-xl m-0 p-0 list-none lg:text-xl`}

    > li {
      margin-bottom: 0;
      display: grid;
      grid-template-rows: auto 1fr;
      grid-template-columns: 1fr auto;

      &[data-section] {
        ${tw`hidden`}
      }

      [data-section="Residential"] ~ .tray &[data-section="Residential"],
      [data-section="Business"] ~ .tray &[data-section="Business"] {
        ${tw`grid`}
      }

      > a {
        grid-row: 1 / 2;
        grid-column: 1 / 3;
        z-index: 1;

        &.highlight {
          ${tw`text-primary`}
        }

        &.button {
          ${tw`flex items-center justify-center text-primary mx-4 border-primary border-2 rounded-xl text-center justify-center mt-4`}
        }
      }

      &.is-small > a {
        font-size: 82%;
      }

      > ul {
        grid-row: 2 / 3;
        grid-column: 1 / 3;
        max-height: 0;
        font-size: 80%;
        overflow: hidden;
        background-color: rgba(255, 255, 255, 0.15);
      }

      > button.is-active + ul {
        max-height: inherit;
      }

      > button.is-active svg {
        transform: rotate(180deg);
      }

      &.nav__special-link {
        padding-left: 1rem;
        padding-right: 1rem;

        > a {
          display: inline-flex;
          justify-content: center;
        }
      }
    }
  }

  .nav__link > span {
    display: none;
  }

  .material-icons {
    ${tw`text-3xl`}
  }

  .nav__link-toggle {
    ${tw`flex font-semibold items-center justify-between py-2 px-[2vmax]`}

    &[aria-selected="true"] + ul {
      max-height: inherit;
    }

    &[aria-selected="true"] {
      ${tw`text-primary`}
    }

    &[aria-selected="true"] svg {
      ${tw`transform rotate-180`}
    }
  }

  a {
    color: rgba(255, 255, 255, 0.85);
    padding: 0 2vmax;
    height: var(--line-height);
    line-height: var(--line-height);
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
    font-weight: 600;
    outline: none;

    &:focus-visible {
      ${tw`text-orange`}
    }

    @media (hover: hover) {
      &:hover,
      &:active {
        cursor: pointer;
        ${tw`cursor-pointer text-primary`}
      }
    }
  }

  li a.is-active {
    background-color: rgba(255, 255, 255, 0.15);
    color: white;

    + button {
      color: white;
    }
  }
`
